import { useState, useRef, useCallback } from 'react'
import { produce, setAutoFreeze } from 'immer'

// setAutoFreeze(false)

// NOTE: immer doesnt work with SES lockdown, but for now we dont need it anyway

export function useHistory(initialData, maxHistory = 20) {
  const apiRef = useRef({})
  const [, forceRender] = useState(0)

  const dataRef = useRef(initialData)
  const committedRef = useRef(initialData)
  const historyRef = useRef({ past: [], future: [] })
  const maxHistoryRef = useRef(maxHistory)

  const edit = fn => {
    dataRef.current = produce(dataRef.current, draft => {
      fn(draft)
    })
    forceRender(n => n + 1)
  }

  const commit = () => {
    if (dataRef.current === committedRef.current) {
      console.log('same')
      return
    }
    console.log('not-same')

    const history = historyRef.current
    const maxSize = maxHistoryRef.current

    history.past.push(committedRef.current)

    if (history.past.length > maxSize) {
      history.past.splice(0, history.past.length - maxSize)
    }

    history.future.length = 0
    committedRef.current = dataRef.current
  }

  const undo = () => {
    const history = historyRef.current
    if (!history.past.length) return

    history.future.push(committedRef.current)
    const previous = history.past.pop()
    committedRef.current = previous
    dataRef.current = previous
    forceRender(n => n + 1)
  }

  const redo = () => {
    const history = historyRef.current
    if (!history.future.length) return

    const maxSize = maxHistoryRef.current

    history.past.push(committedRef.current)

    if (history.past.length > maxSize) {
      history.past.splice(0, history.past.length - maxSize)
    }

    const next = history.future.pop()
    committedRef.current = next
    dataRef.current = next
    forceRender(n => n + 1)
  }

  apiRef.current.data = dataRef.current
  apiRef.current.edit = edit
  apiRef.current.commit = commit
  apiRef.current.undo = undo
  apiRef.current.redo = redo

  return apiRef.current
}
